export default "__VITE_ASSET__7f85b945__"